import React from "react";
import { Input } from "reactstrap";
export function FuelTypeSelector(props) {
    return React.createElement(Input, { type: "text", id: props.id, name: props.name, className: props.className, value: props.value, onChange: function (e) { return props.onChange(e.target.value); } });
}
